"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aboutDetail = exports.aboutUsList = void 0;
const vue_1 = __importDefault(require("vue"));
const http = () => {
    return vue_1.default.prototype.$http;
};
// 关于我们
exports.aboutUsList = (params) => http().post('/protocol/typeList', params);
// 跳转详情
exports.aboutDetail = (params) => http().post('/protocol/content', params);
